import React from "react";
import { Outlet } from "react-router-dom";

const PublicWrapper = () => {
  return <Outlet />;
};

export default PublicWrapper;
